import 'PublicPath';

import { renderSsrClient } from 'rendering/client/renderSsrClient';

import MainApp from './MainApp.dynamic';
import { configureMainStore } from './store/configureMainStore';

renderSsrClient({ Component: MainApp, createStore: configureMainStore });
